import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time',
  standalone: false,
})
export class TimePipe implements PipeTransform {
  transform(value: string): string {
    if (value.length === 4) {
      const hours = value.substring(0, 2);
      const min = value.substring(2);
      return hours.concat(':', min);
    }
    return value;
  }
}
